define("shared/utils/formatters/create-formatted-industry-hashtags", ["exports", "@ember/object", "lodash", "later/utils/object-methods"], function (_exports, _object, _lodash, _objectMethods) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"lodash",0,"later/utils/object-methods"eaimeta@70e063a35619d71f
  /**
   * Transform a raw hashtag item into a formatted one
   */
  function formattedHashtagItem(rawHashtagItem, totalPosts, rank) {
    return _object.default.create({
      tag: rawHashtagItem.tag,
      hashtag: rawHashtagItem.tag,
      numberOfPosts: rawHashtagItem.numberOfPosts,
      percentagePosts: rawHashtagItem.numberOfPosts / totalPosts * 100,
      rank,
      type: 'industry'
    });
  }

  /**
   * Format a raw industry hashtags response, by formatting each hashtag item
   */
  function formattedIndustryHashtags(rawIndustryHashtags) {
    const orderedHashtags = (0, _lodash.orderBy)(rawIndustryHashtags.hashtags, ['numberOfPosts'], ['desc']);
    const formattedHashtags = orderedHashtags.map((rawHashtag, index) => formattedHashtagItem(rawHashtag, rawIndustryHashtags.totalPosts, index + 1));
    return _object.default.create({
      startTime: rawIndustryHashtags.startTime,
      endTime: rawIndustryHashtags.endTime,
      hashtags: formattedHashtags,
      totalPosts: rawIndustryHashtags.totalPosts
    });
  }

  /**
   * Create a standardized formatted industry hashtags dataset
   */
  function createFormattedIndustryHashtags(rawIndustryHashtags) {
    const sanitizedIndustryHashtags = _sanitizeRawIndustryHashtags(rawIndustryHashtags);
    return formattedIndustryHashtags(sanitizedIndustryHashtags);
  }

  /**
   * Formats the raw industry hashtags data to use camel case
   * instead of snake case for all key names
   * by calling @objectSnakeToCamel, and converting all unix
   * dates to Number values
   */
  const _sanitizeRawIndustryHashtags = rawIndustryHashtags => {
    // Note: this only applies when running mirage
    if (rawIndustryHashtags.id) {
      delete rawIndustryHashtags.id;
    }
    const sanitizedIndustryHashtags = {};
    sanitizedIndustryHashtags.hashtags = rawIndustryHashtags.hashtags.map(hashtag => (0, _objectMethods.objectSnakeToCamel)(hashtag));
    sanitizedIndustryHashtags.startTime = Number(rawIndustryHashtags.start_time);
    sanitizedIndustryHashtags.endTime = Number(rawIndustryHashtags.end_time);
    sanitizedIndustryHashtags.totalPosts = Number(rawIndustryHashtags.total_posts);
    return sanitizedIndustryHashtags;
  };
  var _default = _exports.default = createFormattedIndustryHashtags;
});